import React from 'react'
import PropTypes from 'prop-types'

import { HBox } from 'app/views/core/Box'

/** Main container for a full-screen app UI that runs any kind of content. */
function ContentUI(props) {
  const { children } = props
  return (
    <HBox className="content-area">
      {children}
    </HBox>
  )
}
ContentUI.propTypes = {
  children: PropTypes.any,
}

export default ContentUI
